module.exports = __webpack_public_path__ + "img/step6-no.b010f587.png";